import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { FilePage } from './FilePage';
import { faqs } from '../data/faqs';
export function FaqFile() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);
  return <FilePage id="faq" number="07" label="FAQ · Manejo de Objeciones" data-id="element-198" data-mp="3d7i3h22ngb7e">
      <div className="max-w-[46rem] space-y-3" data-id="element-199" data-mp="3d9m337timo1v">
        {faqs.map((faq, index) => {
        const isOpen = openId === faq.id;
        return <motion.div key={faq.id} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.5,
          delay: index * 0.06
        }} className="overflow-hidden rounded-lg border border-white/[0.08] bg-panel" data-id="element-200" data-mp="2kjm8c1sqarcq" data-mpi={index}>
              <h3 data-id="element-201" data-mp="8ta4ilvss26v">
                <button type="button" onClick={() => setOpenId(isOpen ? null : faq.id)} aria-expanded={isOpen} aria-controls={`faq-panel-${faq.id}`} className="flex w-full items-center gap-3 px-5 py-4 text-left transition-colors hover:bg-white/[0.02] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gold" data-id="element-202" data-mp="8ttcb9rqha76">
                  <span className="font-mono text-[10px] text-gold-dim" data-id="element-203" data-mp="2uuxx7d8ojyqa">
                    Q{String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="flex-1 text-[14.5px] font-bold text-gold" data-id="element-204" data-mp="22694o2lox1q5">
                    {faq.question}
                  </span>
                  <Plus aria-hidden="true" className={`h-4 w-4 flex-shrink-0 text-gold transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-205" data-mp="274amkk7dqv01" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-206" data-mp="1jeq0hsfxjhmj">
                {isOpen ? <motion.div id={`faq-panel-${faq.id}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.32,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-207" data-mp="1bejq2cb3y7tl">
                    <p className="border-t border-white/[0.06] px-5 py-4 pl-[3.4rem] text-[13.5px] leading-relaxed text-ash" data-id="element-208" data-mp="1g8eflwde9h0l">
                      {faq.answer}
                    </p>
                  </motion.div> : null}
              </AnimatePresence>
            </motion.div>;
      })}
      </div>
    </FilePage>;
}